var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h1", { staticClass: "title" }, [
        _vm._v(
          _vm._s(_vm.isMa ? "Pesquisa de processo" : "Pesquisa de relatórios")
        )
      ]),
      _c(
        "el-row",
        { attrs: { gutter: 10 } },
        [
          _c(
            "el-col",
            { attrs: { lg: 6, md: 12, sm: 24 } },
            [
              _c("p", { staticClass: "label" }, [
                _vm._v("Nome/Razão social do interessado:")
              ]),
              _c("el-input", {
                staticClass: "input",
                attrs: { name: "nomeInteressado", type: "text" },
                nativeOn: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.consultar($event)
                  }
                },
                model: {
                  value: _vm.filtroSearch.nomeInteressado,
                  callback: function($$v) {
                    _vm.$set(_vm.filtroSearch, "nomeInteressado", $$v)
                  },
                  expression: "filtroSearch.nomeInteressado"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { lg: 6, md: 12, sm: 24 } },
            [
              _c("p", { staticClass: "label" }, [
                _vm._v("CPF/CNPJ do interessado:")
              ]),
              _c("el-input", {
                directives: [
                  {
                    name: "mask",
                    rawName: "v-mask",
                    value: ["###.###.###-##", "##.###.###/####-##"],
                    expression: "['###.###.###-##', '##.###.###/####-##']"
                  }
                ],
                attrs: { type: "text", name: "cpfInteressado" },
                nativeOn: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.consultar($event)
                  }
                },
                model: {
                  value: _vm.filtroSearch.cpfInteressado,
                  callback: function($$v) {
                    _vm.$set(_vm.filtroSearch, "cpfInteressado", $$v)
                  },
                  expression: "filtroSearch.cpfInteressado"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { lg: 6, md: 12, sm: 24 } },
            [
              _c("p", { staticClass: "label" }, [
                _vm._v("Número do processo:")
              ]),
              _c("el-input", {
                staticClass: "input",
                attrs: { name: "numeroProcesso", type: "text" },
                nativeOn: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.consultar($event)
                  }
                },
                model: {
                  value: _vm.filtroSearch.numeroProcesso,
                  callback: function($$v) {
                    _vm.$set(_vm.filtroSearch, "numeroProcesso", $$v)
                  },
                  expression: "filtroSearch.numeroProcesso"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { lg: 6, md: 12, sm: 24 } },
            [
              _c("p", { staticClass: "label" }, [
                _vm._v("Número do comprovante:")
              ]),
              _c("el-input", {
                staticClass: "input",
                attrs: { name: "numeroComprovante", type: "text" },
                nativeOn: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.consultar($event)
                  }
                },
                model: {
                  value: _vm.filtroSearch.numeroComprovante,
                  callback: function($$v) {
                    _vm.$set(_vm.filtroSearch, "numeroComprovante", $$v)
                  },
                  expression: "filtroSearch.numeroComprovante"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 10 } },
        [
          _c(
            "el-col",
            { attrs: { lg: 6, md: 12, sm: 24 } },
            [
              _c("p", { staticClass: "label" }, [
                _vm._v("Período de cadastro:")
              ]),
              _c("el-date-picker", {
                staticClass: "full-width input date",
                attrs: {
                  type: "daterange",
                  "start-placeholder": "Data inicial",
                  "end-placeholder": "Data Final",
                  format: "dd/MM/yyyy",
                  name: "dataCadastro"
                },
                model: {
                  value: _vm.dataCadastro,
                  callback: function($$v) {
                    _vm.dataCadastro = $$v
                  },
                  expression: "dataCadastro"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { lg: 6, md: 12, sm: 24 } },
            [
              _c("p", { staticClass: "label" }, [_vm._v("Tipo de processo:")]),
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "clearable",
                    filterable: "filterable",
                    multiple: "multiple",
                    name: "tiposProcesso"
                  },
                  nativeOn: {
                    keyup: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.consultar($event)
                    }
                  },
                  model: {
                    value: _vm.filtroSearch.tiposProcesso,
                    callback: function($$v) {
                      _vm.$set(_vm.filtroSearch, "tiposProcesso", $$v)
                    },
                    expression: "filtroSearch.tiposProcesso"
                  }
                },
                _vm._l(_vm.getOrdered(_vm.tiposProcesso), function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.nome, value: item.codigo }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { lg: 6, md: 12, sm: 24 } },
            [
              _c("p", { staticClass: "label" }, [_vm._v("Município:")]),
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "clearable",
                    filterable: "filterable",
                    multiple: "multiple",
                    name: "municipio",
                    "collapse-tags": "collapse-tags"
                  },
                  nativeOn: {
                    keyup: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.consultar($event)
                    }
                  },
                  model: {
                    value: _vm.filtroSearch.municipios,
                    callback: function($$v) {
                      _vm.$set(_vm.filtroSearch, "municipios", $$v)
                    },
                    expression: "filtroSearch.municipios"
                  }
                },
                _vm._l(_vm.municipios, function(item) {
                  return _c("el-option", {
                    key: item.nome,
                    attrs: { label: item.nome, value: item.id }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { lg: 6, md: 12, sm: 24 } },
            [
              _c("p", { staticClass: "label" }, [
                _vm._v("Situação do processo:")
              ]),
              _vm.isEstadoAP
                ? _c(
                    "el-select",
                    {
                      attrs: {
                        clearable: "clearable",
                        filterable: "filterable",
                        multiple: "multiple",
                        "collapse-tags": "collapse-tags",
                        name: "situacoesProcesso"
                      },
                      nativeOn: {
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.consultar($event)
                        }
                      },
                      model: {
                        value: _vm.filtroSearch.situacoesProcesso,
                        callback: function($$v) {
                          _vm.$set(_vm.filtroSearch, "situacoesProcesso", $$v)
                        },
                        expression: "filtroSearch.situacoesProcesso"
                      }
                    },
                    _vm._l(_vm.listaStatusAmapa, function(item) {
                      return _c("el-option", {
                        key: item.codigo,
                        staticClass: "inputSelect",
                        attrs: { label: item.nome, value: item.codigo }
                      })
                    }),
                    1
                  )
                : _c(
                    "el-select",
                    {
                      attrs: {
                        clearable: "clearable",
                        filterable: "filterable",
                        multiple: "multiple",
                        "collapse-tags": "collapse-tags",
                        name: "situacoesProcesso"
                      },
                      nativeOn: {
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.consultar($event)
                        }
                      },
                      model: {
                        value: _vm.filtroSearch.situacoesProcesso,
                        callback: function($$v) {
                          _vm.$set(_vm.filtroSearch, "situacoesProcesso", $$v)
                        },
                        expression: "filtroSearch.situacoesProcesso"
                      }
                    },
                    _vm._l(_vm.getStatusFormatted(_vm.status), function(item) {
                      return _c("el-option", {
                        key: item.codigo,
                        staticClass: "inputSelect",
                        attrs: { label: item.nome, value: item.codigo }
                      })
                    }),
                    1
                  )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 10 } },
        [
          _c(
            "el-col",
            { attrs: { lg: 6, md: 12, sm: 24 } },
            [
              _c("p", { staticClass: "label" }, [
                _vm._v("Processos que estão no setor:")
              ]),
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "clearable",
                    filterable: "filterable",
                    multiple: "multiple",
                    "collapse-tags": "collapse-tags",
                    name: "processosSetor"
                  },
                  on: { input: _vm.handleChangeSetorAtual },
                  nativeOn: {
                    keyup: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.consultar($event)
                    }
                  },
                  model: {
                    value: _vm.filtroSearch.setoresAtuais,
                    callback: function($$v) {
                      _vm.$set(_vm.filtroSearch, "setoresAtuais", $$v)
                    },
                    expression: "filtroSearch.setoresAtuais"
                  }
                },
                _vm._l(_vm.getSetorFormatted(_vm.setores), function(item) {
                  return _c("el-option", {
                    key: item.codigo,
                    attrs: {
                      label: _vm.formatLabelSetor(item),
                      value: item.codigo
                    }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { lg: 6, md: 12, sm: 24 } },
            [
              _c("p", { staticClass: "label" }, [
                _vm._v("Técnicos responsáveis:")
              ]),
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "clearable",
                    filterable: "filterable",
                    multiple: "multiple",
                    "collapse-tags": "collapse-tags",
                    name: "responsaveisAtuais",
                    disabled:
                      _vm.filtroSearch.setoresAtuais &&
                      _vm.filtroSearch.setoresAtuais.length === 0
                  },
                  nativeOn: {
                    keyup: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.consultar($event)
                    }
                  },
                  model: {
                    value: _vm.filtroSearch.responsaveisAtuais,
                    callback: function($$v) {
                      _vm.$set(_vm.filtroSearch, "responsaveisAtuais", $$v)
                    },
                    expression: "filtroSearch.responsaveisAtuais"
                  }
                },
                _vm._l(
                  _vm.getTecnicosFormatted(_vm.responsaveisAtuais),
                  function(item) {
                    return _c("el-option", {
                      key: item.id,
                      attrs: { label: item.nome, value: item.id }
                    })
                  }
                ),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { lg: 6, md: 12, sm: 24 } },
            [
              _c("p", { staticClass: "label" }, [
                _vm._v("Processos que passaram pelo setor:")
              ]),
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "clearable",
                    filterable: "filterable",
                    multiple: "multiple",
                    "collapse-tags": "collapse-tags",
                    name: "processosSetorPassado"
                  },
                  on: { input: _vm.handleChangeSetorPassados },
                  nativeOn: {
                    keyup: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.consultar($event)
                    }
                  },
                  model: {
                    value: _vm.filtroSearch.setoresPassados,
                    callback: function($$v) {
                      _vm.$set(_vm.filtroSearch, "setoresPassados", $$v)
                    },
                    expression: "filtroSearch.setoresPassados"
                  }
                },
                _vm._l(_vm.getSetorFormatted(_vm.setores), function(item) {
                  return _c("el-option", {
                    key: item.codigo,
                    attrs: {
                      label: _vm.formatLabelSetor(item),
                      value: item.codigo
                    }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { lg: 6, md: 12, sm: 24 } },
            [
              _c("p", { staticClass: "label" }, [
                _vm._v("Técnicos responsáveis passados:")
              ]),
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "clearable",
                    filterable: "filterable",
                    multiple: "multiple",
                    "collapse-tags": "collapse-tags",
                    name: "responsaveisPassados",
                    disabled:
                      _vm.filtroSearch.setoresPassados &&
                      _vm.filtroSearch.setoresPassados.length === 0
                  },
                  nativeOn: {
                    keyup: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.consultar($event)
                    }
                  },
                  model: {
                    value: _vm.filtroSearch.responsaveisPassados,
                    callback: function($$v) {
                      _vm.$set(_vm.filtroSearch, "responsaveisPassados", $$v)
                    },
                    expression: "filtroSearch.responsaveisPassados"
                  }
                },
                _vm._l(
                  _vm.getTecnicosFormatted(_vm.responsaveisPassados),
                  function(item) {
                    return _c("el-option", {
                      key: item.id,
                      attrs: { label: item.nome, value: item.id }
                    })
                  }
                ),
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 10 } },
        [
          _vm.isEstadoPA || _vm.isEstadoAP
            ? _c(
                "el-col",
                { attrs: { lg: 6, md: 12, sm: 24 } },
                [
                  _c("p", { staticClass: "label" }, [
                    _vm._v("Interseção com camada de bloqueio")
                  ]),
                  _c(
                    "el-select",
                    {
                      attrs: {
                        clearable: "clearable",
                        filterable: "filterable",
                        "collapse-tags": "collapse-tags",
                        name: "statusBloqueioDinamico"
                      },
                      nativeOn: {
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.consultar($event)
                        }
                      },
                      model: {
                        value: _vm.filtroSearch.statusBloqueioDinamico,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.filtroSearch,
                            "statusBloqueioDinamico",
                            $$v
                          )
                        },
                        expression: "filtroSearch.statusBloqueioDinamico"
                      }
                    },
                    _vm._l(_vm.statusBloqueioDinamico, function(item) {
                      return _c("el-option", {
                        key: item.codigo,
                        attrs: { label: item.descricao, value: item.codigo }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.isEstadoPA
            ? _c(
                "el-col",
                { attrs: { lg: 6, md: 12, sm: 24 } },
                [
                  _c("p", { staticClass: "label" }, [
                    _vm._v("Monitoramento ambiental")
                  ]),
                  _c(
                    "el-select",
                    {
                      attrs: {
                        clearable: "clearable",
                        filterable: "filterable",
                        "collapse-tags": "collapse-tags",
                        name: "statusAmbiental"
                      },
                      nativeOn: {
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.consultar($event)
                        }
                      },
                      model: {
                        value: _vm.filtroSearch.statusAmbiental,
                        callback: function($$v) {
                          _vm.$set(_vm.filtroSearch, "statusAmbiental", $$v)
                        },
                        expression: "filtroSearch.statusAmbiental"
                      }
                    },
                    _vm._l(_vm.statusAmbiental, function(item) {
                      return _c("el-option", {
                        key: item.codigo,
                        attrs: { label: item.descricao, value: item.codigo }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c("el-row", { attrs: { gutter: 10 } }, [
        _c(
          "div",
          { staticClass: "row" },
          [
            _c("span", { on: { click: _vm.exibirBuscaPorLote } }, [
              _c("p", { staticClass: "busca" }, [_vm._v("Pesquisa por lote")])
            ]),
            _c(
              "el-tooltip",
              { attrs: { effect: "dark", placement: "top-end" } },
              [
                _c("i", { staticClass: "el-icon-info icon-info" }),
                _c("template", { slot: "content" }, [
                  _vm._v(
                    "Para realizar a pesquisa de mais de um processo, insira a planilha contendo os números dos processos a serem pesquisados de acordo com o modelo a seguir. "
                  ),
                  _c(
                    "a",
                    {
                      staticClass: "btn-download",
                      on: { click: _vm.baixarModelo }
                    },
                    [_vm._v("(Baixar modelo)")]
                  )
                ])
              ],
              2
            )
          ],
          1
        ),
        _c(
          "div",
          [
            _vm.showPesquisaLote
              ? _c("app-upload-area", {
                  attrs: {
                    id: "lote",
                    target: "publico/upload",
                    fileType: _vm.validExtensions,
                    onSuccess: _vm.onSuccess,
                    documento: _vm.file,
                    hasDownloadButton: false
                  },
                  on: { removerDocumento: _vm.removerDocumento },
                  model: {
                    value: _vm.file,
                    callback: function($$v) {
                      _vm.file = $$v
                    },
                    expression: "file"
                  }
                })
              : _vm._e()
          ],
          1
        )
      ]),
      _c(
        "el-row",
        { staticClass: "button-row" },
        [
          _c("span", { staticClass: "limpar", on: { click: _vm.limpar } }, [
            _vm._v("Limpar")
          ]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.consultar } },
            [_c("i", { staticClass: "icon fa fa-search" }), _vm._v("Pesquisar")]
          )
        ],
        1
      ),
      _c("h1", [_vm._v("Resultado da pesquisa")]),
      _c(
        "div",
        [
          _c("app-listagem-processos-relatorio", {
            attrs: {
              processos: _vm.processos.content,
              totalItems: _vm.processos.totalElements || 0,
              "page-size": _vm.pageSize,
              currentPage: _vm.page,
              loading: _vm.loadingTable
            },
            on: {
              "update:totalItems": function($event) {
                return _vm.$set(_vm.processos, "totalElements || 0", $event)
              },
              "update:total-items": function($event) {
                return _vm.$set(_vm.processos, "totalElements || 0", $event)
              },
              changePage: _vm.changePage,
              clicked: _vm.onClickedProcessoListagem,
              changeOrder: _vm.changeOrder
            }
          })
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "button-row" },
        [
          _c(
            "el-button",
            {
              staticClass: "right",
              attrs: {
                type: "default",
                size: "small",
                disabled: _vm.disableExportarCSV
              },
              on: { click: _vm.getCsv }
            },
            [
              _c("i", { staticClass: "fal fa-file-csv" }),
              _c("span", [_vm._v("  Exportar CSV")])
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ac9adf72", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ac9adf72","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/relatorios/components/gerais/AppListagemRelatorio.vue
// module id = null
// module chunks = 